import React, { Component } from "react";

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  IconButton
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";

import { withStyles } from "@material-ui/core/styles";

import { toast } from "react-toastify";

import { store } from "../firebase";

import { filterNotRemoved } from "../utils";

import * as modals from "../constants/modals";

import withCrewAuthorization from "../components/withCrewAuthorization";

import Confirm from "../modals/Confirm";

import CrewHeader from "../components/CrewHeader";
import DayFooter from "../components/DayFooter";

const styles = (theme) => ({
  root: {
    flexGrow: 1
  },
  services: {
    minHeight: "calc(100vh - 114px)"
  },
  serviceColor: {
    width: 10,
    height: 10,
    borderRadius: 5,
    marginRight: 10
  }
});

class ServicesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirm: {
        open: false
      }
    };
  }

  handleServiceAdd = () => {
    const { openModal } = this.props;

    openModal(modals.ADD_SERVICE);
  };

  handleServiceEdit = (service) => (event) => {
    const { openModal } = this.props;

    openModal(modals.EDIT_SERVICE, {
      service
    });
  };

  handleConfirmServiceRemove = (service) => (event) => {
    event.preventDefault();

    this.setState({
      serviceToRemove: service,
      confirm: {
        open: true,
        description: "Ben je zeker dat je deze behandeling wil verwijderen?"
      }
    });
  };

  handleConfirmClick = () => {
    const service = this.state.serviceToRemove;

    this.setState(
      {
        confirm: {
          open: false
        },
        serviceToRemove: undefined
      },
      () => {
        this.handleServiceRemove(service);
      }
    );
  };

  handleCancelClick = () => {
    this.setState(
      {
        confirm: {
          open: false
        },
        serviceToRemove: undefined
      },
      () => {}
    );
  };

  handleServiceRemove = (service) => {
    const { shop } = this.props;

    const toastId = toast("Behandeling verwijderen...", {
      autoClose: false
    });

    store
      .removeService(shop.id, service.id)
      .then(() => {
        toast.update(toastId, {
          render: "Behandeling verwijderd",
          type: toast.TYPE.INFO,
          autoClose: 3000
        });
      })
      .catch((error) => {
        toast.update(toastId, {
          render: `Er ging iets fout (${error.toString()})`,
          type: toast.TYPE.ERROR,
          autoClose: 5000
        });
      });
  };

  render() {
    const { shop, info, services, toggleDrawer, classes } = this.props;
    const { confirm } = this.state;

    return (
      <div className={classes.root}>
        <Confirm
          open={confirm.open}
          description={confirm.description}
          handleConfirm={this.handleConfirmClick}
          handleCancel={this.handleCancelClick}
        />
        <CrewHeader
          title="Behandelingen"
          toggleDrawer={toggleDrawer}
          buttons={[
            <IconButton onClick={this.handleServiceAdd}>
              <AddIcon />
            </IconButton>
          ]}
        />
        <List className={classes.services}>
          {services &&
            filterNotRemoved(services).map((service, index) => (
              <ListItem key={index} onClick={this.handleServiceEdit(service)}>
                <ListItemIcon>
                  <div
                    className={classes.serviceColor}
                    style={{
                      background: service.color ? service.color : "black"
                    }}
                  ></div>
                </ListItemIcon>
                <ListItemText primary={service.name} />
                <ListItemSecondaryAction>
                  <IconButton
                    onClick={this.handleConfirmServiceRemove(service)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
        </List>
        <DayFooter
          shop={shop}
          info={info}
          hideService={true}
          hideBarber={true}
          hideCustomer={true}
          hideCrew={true}
        />
      </div>
    );
  }
}

export default withCrewAuthorization()(withStyles(styles)(ServicesPage));
